import config from '@/config';
import { ExtendExpirationCoreCommandParams, InitializeAccountCoreCommandParams } from '@stellab/cs-schemas';

import { getAxios } from './axios';

export const sendInitializeAccountCommand = (
  data: Omit<InitializeAccountCoreCommandParams, 'timestamp'> & { passphrase: string },
) => {
  const url = `${config.backend}/blockchain/initialize`;

  return getAxios().post(url, data);
};

export const sendExtendExpirationCommand = (
  data: Omit<ExtendExpirationCoreCommandParams, 'timestamp'> & { passphrase: string },
) => {
  const url = `${config.backend}/blockchain/extend-expiration`;

  return getAxios().post<{ asset: ExtendExpirationCoreCommandParams }>(url, data);
};
